export default __webpack_public_path__ + "static/media/choose-in.ccd0529b.wav";